import type { ConsoleEvalStatus } from '@plato/shared';

export function OutcomeChip(props: { status: ConsoleEvalStatus }) {
  const tone =
    props.status === 'passed'
      ? 'chip chip-success'
      : props.status === 'failed' || props.status === 'errored'
        ? 'chip chip-warning'
        : 'chip';
  return <span className={tone}>{LABELS[props.status]}</span>;
}

export function outcomeOf(result: { passed: boolean; errored: boolean }): ConsoleEvalStatus {
  if (result.errored) return 'errored';
  return result.passed ? 'passed' : 'failed';
}

export function isFinished(status: ConsoleEvalStatus): boolean {
  return status !== 'queued' && status !== 'running';
}

const LABELS: Readonly<Record<ConsoleEvalStatus, string>> = {
  queued: 'Queued',
  running: 'Running',
  passed: 'Passed',
  failed: 'Failed',
  errored: 'Errored',
};
